export default "/images/vendor/flag-icon-css/flags/1x1/eu.svg?1019087b8a58ac24c4ea6304579bdd0f";